/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'DEDUCTIONS_ARE_VOLUNTARILY_ACCEPTED_BY_WORKERS',
              'WORKERS_SIGN_A_DOCUMENT_IN_A_LANGUAGE_THEY_UNDERSTAND_GIVING_CO',
              'DEDUCTIONS_TO_WAGES_ARE_EXPLAINED_TO_WORKERS',
              'WORKERS_HAVE_ACCESS_TO_THE_ACCOUNT_STATUS_OF_ALL_WAGE_DEDUCTION',
              'NONE_OF_THE_ABOVE',
              'IS_THE_FACILITY_FAILING_TO_COLLECT_AND_FORWARD_SOCIAL_INSURANCE',
              'NOT_APPLICABLE_WORKER_AND_FACILITY_CONTRIBUTIONS_CANNOT_BE_SEPA',
              'NONE_OF_THE_ABOVE_FACILITY_COLLECTS_AND_FORWARDS_ALL_LEGALLY_RE',
              'TOTAL_WORKER_CONTRIBUTION_AMOUNT_NO_BREAKDOWN_POSSIBLE_COLLECTE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    if_yes_does_the_fac_follow_any_of_the_following_practices_regar: valueSchema,
  },
}
